
<template>
  <div>
    <page-title>Dashboard</page-title>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <div class="columns flex-row wrap justify-space-evenly">
      <div class="column">
        <DashboardCard
          title="Total Users"
          :data="allUsers.length || 0"
          link="all-users"
        ></DashboardCard>
      </div>
      <div v-if="isHudsontridentUser" class="column">
        <DashboardCard
          title="Port Users"
          :data="allUsersForPort.length || 0"
          link="all-users"
        ></DashboardCard>
      </div>

      <div v-if="isHudsontridentUser" class="column">
        <DashboardCard
          title="NIMASA Admin Users"
          :data="allUsersForNimasaAdmin.length || 0"
          link="all-users"
        ></DashboardCard>
      </div>
      <div v-if="isNimasaAdmin" class="column">
        <DashboardCard
          title="NIMASA Manager Users"
          :data="allUsersForNimasaManager.length || 0"
          link="all-users"
        ></DashboardCard>
      </div>
      <div v-if="isNimasaAdmin" class="column">
        <DashboardCard
          title="NIMASA Officer Users"
          :data="allUsersForNimasaAgent.length || 0"
          link="all-users"
        ></DashboardCard>
      </div>
    </div>
  </div>
</template>


<script>
import { ADMIN_MUTATION_TYPES } from "@/store/mutation-types";
import AdminUsersQuery from "../api/graphql/queries/AdminUsersQuery";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapMutations } = createNamespacedHelpers("admin");
import DashboardCard from "../components/DashboardCard"
import { ROOT_MUTATION_TYPES } from "@/store/mutation-types.js";
import GetPortsQuery from "@/modules/commonModule/api/graphql/queries/GetPorts";
import {
  mapGetters as mapRootGetters,
  mapMutations as mapRootMutations
} from "vuex";

export default {
  name: "admin-dashboard",
  components: {DashboardCard},
  data() {
    return {
      isLoading: false,
      currentPage: 1,
      total: 0
    };
  },
  created: function() {
    if (!this.portsFromVuex.loaded) {
      this.loadPortsFromAPI();
    }
  },
  mounted() {
    /**
     * Load the NIMASA Admin users from the api on mount
     */
    if (this.isNimasaAdmin) {
      this.loadUsersNimasaAgentFromAPI(this.currentPage);
      this.loadUsersNimasaManagerFromAPI(this.currentPage);
    }

    /**
     * Load the Hudsontrident Admin users from the api on mount
     */

    if (this.isHudsontridentUser) {
      this.loadUsersForNimasaAdminFromAPI(this.currentPage);
      this.loadUsersPortFromAPI(this.currentPage);
    }
  },
  computed: {
    ...mapRootGetters({
      portsFromVuex: "getPorts",
    }),
    ...mapGetters({
      isHudsontridentUser: "isHudsontridentUser",
      isNimasaAdmin: "isNimasaAdmin",
      allUsersForNimasaAdmin: "getAllUsersForNimasaAdminUser",
      allUsersForPort: "getAllUsersForPort",
      allUsersForNimasaManager: "getAllUsersForNimasaManager",
      allUsersForNimasaAgent: "getAllUsersForNimasaAgent"
    }),
    allUsers: function() {
      if (this.isNimasaAdmin) {
        return this.allUsersForNimasaManager.concat(this.allUsersForNimasaAgent);
      }
      if (this.isHudsontridentUser) {
        return this.allUsersForNimasaAdmin.concat(this.allUsersForPort);
      }
    }
  },
  methods: {
    ...mapRootMutations({
      updatePorts: ROOT_MUTATION_TYPES.SAVE_PORTS
    }),
    ...mapMutations({
      saveNimasaAdminUsers: ADMIN_MUTATION_TYPES.SAVE_NIMASA_ADMIN_USERS,
      savePortUsers: ADMIN_MUTATION_TYPES.SAVE_PORT_USERS,
      saveNimasaUsers: ADMIN_MUTATION_TYPES.SAVE_NIMASA_USERS,
      saveNimasaManagerUsers: ADMIN_MUTATION_TYPES.SAVE_NIMASA_MANAGER_USERS
    }),

    loadPortsFromAPI: function() {
      this.isLoading = true;

      this.$apollo
        .query({
          query: GetPortsQuery
        })
        .then(response => {
          const ports = response.data.ports;
          this.updatePorts(ports);
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            message: "Failed to load list of ports",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    loadUsersForNimasaAdminFromAPI: function(page) {
      this.isLoading = true;

      this.$apollo
        .query({
          query: AdminUsersQuery.NimasaAdminUsers,
          variables: {
            page
          }
        })
        .then(response => {
          const users = response.data.GetNimasaAdminUsers.data;
          this.saveNimasaAdminUsers(users);

          const {
            total,
            currentPage
          } = response.data.GetNimasaAdminUsers.paginatorInfo;
          this.total = total;
          this.currentPage = currentPage;

          this.$toast.open({
            duration: 3000,
            position: "is-top-right",
            message: "Users loaded successfully.",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "Failed to load users",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    loadUsersPortFromAPI: function(page) {
      this.isLoading = true;

      this.$apollo
        .query({
          query: AdminUsersQuery.PortUsers,
          variables: {
            page
          }
        })
        .then(response => {
          const users = response.data.GetAllPortUsers.data;
          this.savePortUsers(users);

          const {
            total,
            currentPage
          } = response.data.GetAllPortUsers.paginatorInfo;
          this.total = total;
          this.currentPage = currentPage;

          this.$toast.open({
            duration: 3000,
            position: "is-top-right",
            message: "Users loaded successfully.",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "Failed to load users",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    loadUsersNimasaAgentFromAPI: function(page) {
      this.isLoading = true;

      this.$apollo
        .query({
          query: AdminUsersQuery.NimasaUsers,
          variables: {
            page
          }
        })
        .then(response => {
          const users = response.data.GetNimasaUsers.data;
          this.saveNimasaUsers(users);

          const {
            total,
            currentPage
          } = response.data.GetNimasaUsers.paginatorInfo;
          this.total = total;
          this.currentPage = currentPage;

          this.$toast.open({
            duration: 3000,
            position: "is-top-right",
            message: "Users loaded successfully.",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "Failed to load users",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    loadUsersNimasaManagerFromAPI: function(page) {
      this.isLoading = true;

      this.$apollo
        .query({
          query: AdminUsersQuery.NimasaManagerUsers,
          variables: {
            page
          }
        })
        .then(response => {
          const users = response.data.GetNimasaManagers.data;
          this.saveNimasaManagerUsers(users);

          const {
            total,
            currentPage
          } = response.data.GetNimasaManagers.paginatorInfo;
          this.total = total;
          this.currentPage = currentPage;

          this.$toast.open({
            duration: 3000,
            position: "is-top-right",
            message: "Users loaded successfully.",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "Failed to load users",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onPageChange(page) {
      this.currentPage = page;
      if (this.isNimasaAdmin) {
        this.loadUsersNimasaAgentFromAPI(this.currentPage);
        this.loadUsersNimasaManagerFromAPI(this.currentPage);
      }

      if (this.isHudsontridentUser) {
        this.loadUsersForNimasaAdminFromAPI(this.currentPage);
        this.loadUsersPortFromAPI(this.currentPage);
      }
    }
  }
};
</script>

<style scoped>
.card {
  min-height: 130px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: 1px solid #6e98ff;
  box-shadow: 0px 0px 20px 1px #ccc;
}

.level {
  justify-content: space-evenly !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}
.dashboard-card {
  width: 50%;
}

.columns {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bgColor {
  background-color: #000;
  border: none !important;
}
</style>